<template>
  <div class="w-full h-screen min-h-screen"></div>
</template>

<script>
export default {};
</script>

<style scoped>
</style>